module.exports = __webpack_public_path__ + "media/conmex/gacetas-7cfc67ef.png";